/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ description: NonNullable<unknown> }} Civil_Knotty_Dog_CureInputs */

const fr_civil_knotty_dog_cure = /** @type {(inputs: Civil_Knotty_Dog_CureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La permission ${i?.description} est maintenant héritée du rôle.`)
};

/**

* @param {Civil_Knotty_Dog_CureInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const civil_knotty_dog_cure = /** @type {((inputs: Civil_Knotty_Dog_CureInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Civil_Knotty_Dog_CureInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_civil_knotty_dog_cure(inputs)
});